import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import CustomButton from '../../CustomButton'

const ModalSavePreset = (props) => {
	const { savePreset, closeModal } = props;

	const [name, setName] = useState('');

	return (
		<Modal
			show
			onHide={closeModal}
		>
			<Modal.Header closeButton>
				<Modal.Title className='title'>Save Columns Preset</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="modal-text">
					<input
						value={name}
						onChange={(e) => setName(e.target.value)}
						placeholder={"Name"}
						className='vehicle-search'
					/>
				</div>
			</Modal.Body>
			<Modal.Footer className="default-modal-footer modal-footer">
				<CustomButton variant="primary-outline" onClick={closeModal}>Cancel</CustomButton >
				<CustomButton variant='secondary' onClick={() => savePreset(name)}>SAVE</CustomButton >
			</Modal.Footer>
		</Modal>
	)
}

export default ModalSavePreset;
